import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ms_skeleton_item = _resolveComponent("ms-skeleton-item")!

  return (_ctx.uiLoading)
    ? (_openBlock(), _createElementBlock("div", _mergeProps({
        key: 0,
        class: ['el-skeleton', _ctx.animated ? 'is-animated' : '', ]
      }, _ctx.$attrs), [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.count, (i) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
            (_ctx.loading)
              ? _renderSlot(_ctx.$slots, "template", { key: 0 }, () => [
                  _createVNode(_component_ms_skeleton_item, {
                    class: "is-first",
                    variant: "p"
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (item) => {
                    return (_openBlock(), _createBlock(_component_ms_skeleton_item, {
                      key: item,
                      class: _normalizeClass({
              'el-skeleton__paragraph': true,
              'is-last': item === _ctx.rows && _ctx.rows > 1,
            }),
                      variant: "p"
                    }, null, 8, ["class"]))
                  }), 128))
                ])
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ], 16))
    : _renderSlot(_ctx.$slots, "default", _normalizeProps(_mergeProps({ key: 1 }, _ctx.$attrs)))
}